import state from './route_state'
import getters from './route_getters'
import mutations from './route_mutations'

export default {
    name: 'router',
    state,
    mutations,
    actions: {},
    getters
}
